import {
  IField_JobContextType_Human,
  IField_JobContextType_System,
  IField_JobProgress_Step_Type_Wait,
  IField_JobProgress_Step_Type_Count,
  IField_JobProgress_Step_Type_Progress,
  IField_Job_RunMode_Once,
  IField_Job_RunMode_Restartable,
} from '../types/schema/job'

/*

  job

*/

// update the "seen_at" value every second
export const JOB_SEEN_AT_LOOP_DELAY = 1000
// treat a job as "timedout" if it's not been seen for 10 seconds
export const JOB_TIMEOUT_DELAY = 10 * 1000
// how many times can a job be restarted?
export const JOB_MAX_ATTEMPTS = 3

export const JOB_RUN_MODE_ONCE: IField_Job_RunMode_Once = 'once'
export const JOB_RUN_MODE_RESTARTABLE: IField_Job_RunMode_Restartable = 'restartable'

export const JOB_CONTEXT_TYPE_HUMAN: IField_JobContextType_Human = 'human'
export const JOB_CONTEXT_TYPE_SYSTEM: IField_JobContextType_System = 'system'

export const JOB_NAME_CRM_IMPORT_LOAD = 'crm.import.load'
export const JOB_NAME_CRM_IMPORT_PROCESS = 'crm.import.process'
export const JOB_NAME_CRM_IMPORT_RUN = 'crm.import.run'

export const JOB_NAME_ASTONISH_TEMPLATE_SCREENSHOT = 'astonish.template.screenshot'
export const JOB_NAME_ASTONISH_CAMPAIGN_SCREENSHOT = 'astonish.campaign.screenshot'
export const JOB_NAME_ASTONISH_CAMPAIGN_SCHEDULE = 'astonish.campaign.schedule'
export const JOB_NAME_ASTONISH_CAMPAIGN_SEND = 'astonish.campaign.send'

export const JOB_NAME_KNOWLEDGEBASE_ARTICLE_SCREENSHOT = 'knowledgebase.article.screenshot'

export const JOB_NAME_NOPRESS_PUBLISH_PAGES = 'nopress.publish.pages'

export const JOB_NAME_MARKETING_GENERATE_ORIGINAL_CONTENT = 'marketing.generate.original'
export const JOB_NAME_MARKETING_GENERATE_LOCAL_CONTENT = 'marketing.generate.local'
export const JOB_NAME_MARKETING_SEND_CONTENT = 'marketing.send.content'

export const JOB_NAMES = [
  JOB_NAME_CRM_IMPORT_LOAD,
  JOB_NAME_CRM_IMPORT_PROCESS,
  JOB_NAME_CRM_IMPORT_RUN,
  JOB_NAME_ASTONISH_TEMPLATE_SCREENSHOT,
  JOB_NAME_ASTONISH_CAMPAIGN_SCREENSHOT,
  JOB_NAME_ASTONISH_CAMPAIGN_SCHEDULE,
  JOB_NAME_ASTONISH_CAMPAIGN_SEND,
  JOB_NAME_KNOWLEDGEBASE_ARTICLE_SCREENSHOT,
  JOB_NAME_NOPRESS_PUBLISH_PAGES,
  JOB_NAME_MARKETING_GENERATE_ORIGINAL_CONTENT,
  JOB_NAME_MARKETING_GENERATE_LOCAL_CONTENT,
  JOB_NAME_MARKETING_SEND_CONTENT,
]

export const JOB_PROGRESS_STEP_TYPE_WAIT: IField_JobProgress_Step_Type_Wait = 'wait'
export const JOB_PROGRESS_STEP_TYPE_COUNT: IField_JobProgress_Step_Type_Count = 'count'
export const JOB_PROGRESS_STEP_TYPE_PROGRESS: IField_JobProgress_Step_Type_Progress = 'progress'

export const JOB_PROGRESS_UPDATE_INTERVAL = 1000